export type SearchFunction = (pkg: {
  name: string;
  version: string;
}) => boolean;
